import z from 'zod';

const dateMessage = "Date must be in a format of YYYY-MM-DD";
export const DateSchema = z.union([z.string().regex(/\d{1,2}\/\d{1,2}\/\d{4}/, dateMessage), z.string().regex(/\d{4}-\d{1,2}-\d{1,2}/, dateMessage)]);